const SUPPORT_EMAIL = 'support@theyemma.com';

export default function UserHasNoGroups() {
  return (
    <div className="flex flex-col items-center gap-3 py-12 text-center">
      <h4 className="text-lg font-semibold text-foreground">
        You are not participating in any workspaces at the moment
      </h4>
      <p className="text-sm text-muted-foreground">
        Ask to get invited to a workspace or contact support at{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="text-primary hover:underline">
          {SUPPORT_EMAIL}
        </a>
      </p>
    </div>
  );
}
